@if (options.length) {
  @if (dropdown) {
    <div class="dropdown-trigger" (click)="open($event)" [class.is-open]="isOpen">
      @if (icon) {
        <span class="dropdown-icon mb-icon {{ icon }}" [class.is-open]="isOpen"></span>
      }
      @if (!hideLabel) {
        <span class="dropdown-label" [class.is-open]="isOpen">{{ valueLabel || options[0].label | translate }}</span>
      }
      @if (!hideLabel) {
        <span
          class="dropdown-indicator mb-icon mb-icon-down"
          [class.is-open-top]="openTop"
          [class.invert]="isOpen"
          [class.is-open]="isOpen"
        ></span>
      }
    </div>
    @if (!useNativeSelect) {
      <div class="dropdown-container" [class.open-top]="openTop" [class.is-open]="isOpen">
        <ng-container *ngTemplateOutlet="selectionTpl"></ng-container>
      </div>
    }
    @if (useNativeSelect) {
      <select
        class="maximize-content dropdown-native-container"
        #selectEl
        multiple
        (change)="nativeOptionSelect($event)"
      >
        @for (option of options; track option.value) {
          <option class="mb-dropdown-option" [value]="option.value" [selected]="option.value === value">
            {{ option.label | translate }}
          </option>
        }
      </select>
    }
  } @else {
    <div class="options-wrapper">
      @for (option of options; track option.value) {
        <div class="dropdown-option" (click)="optionSelected($event, option)" [class.active]="option.selected">
          <div class="dropdown-option-label">
            {{ option.label | translate }}
          </div>
          <div class="dropdown-option-checkbox">
            <span class="mb-icon mb-icon-marked-ok"></span>
          </div>
        </div>
      }
    </div>
  }
}

<ng-template #selectionTpl>
  <div class="options-wrapper">
    @for (option of options; track option.value) {
      <div class="dropdown-option" (click)="optionSelected($event, option)" [class.active]="option.selected">
        <div class="dropdown-option-label">
          {{ option.label | translate }}
        </div>
        <div class="dropdown-option-checkbox">
          <span class="mb-icon mb-icon-marked-ok"></span>
        </div>
      </div>
    }
  </div>
</ng-template>
